import script from "./ExpandedTableModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExpandedTableModal.vue?vue&type=script&lang=ts&setup=true"

import "./ExpandedTableModal.vue?vue&type=style&index=0&id=a0ce95f0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0ce95f0"]])

export default __exports__